export default "__VITE_ASSET__pfxP1cEq__"